import React from 'react'
import ViewQuickLinks from '../../Components/QuickLinks/ViewQuickLinks'

const ViewQuickLinksPage = () => {
  return (
    <ViewQuickLinks/>
  )
}

export default ViewQuickLinksPage